import React, { useState, type FC, type Ref } from 'react';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { premiumLandingPageEntryPoint } from '@atlassian/jira-servicedesk-premium-landing-page/entrypoint.tsx';
import { Trigger, usePanel } from '@atlassian/entry-point-panel';
import { fireUIAnalytics, type UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import { useUrlManager } from '../hooks/use-url-manager/index.tsx';
import messages from './messages.tsx';
import type { PremiumLandingPageEntryPointButtonProps } from './types.tsx';

export const PremiumLandingPageEntryPointButtonWithDrawer: FC<
	PremiumLandingPageEntryPointButtonProps
> = ({ origin, buttonLabel }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { formatMessage } = useIntl();
	useUrlManager('jsmPremiumBenefitsOpen', 'true', isModalOpen);

	const onEntryPointButtonClick = (analyticsEvent: UIAnalyticsEvent) => {
		setIsModalOpen(true);
		fireUIAnalytics(analyticsEvent, 'premiumLandingPageEntryPointButton', {
			entryPointOrigin: origin,
		});
	};

	const { Panel, trigger } = usePanel();

	return (
		<>
			<Trigger
				trigger={trigger}
				entryPoint={premiumLandingPageEntryPoint}
				entryPointProps={{
					origin,
					onClose: () => {
						setIsModalOpen(false);
					},
				}}
			>
				{({ ref }) => (
					<Button
						appearance="subtle"
						onClick={(
							_: React.MouseEvent<HTMLElement, MouseEvent>,
							analyticsEvent: UIAnalyticsEvent,
						) => onEntryPointButtonClick(analyticsEvent)}
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						ref={ref as Ref<HTMLButtonElement>}
					>
						{formatMessage(buttonLabel ?? messages.defaultMessage)}
					</Button>
				)}
			</Trigger>
			{isModalOpen && <Panel />}
		</>
	);
};
